/** error codes that can be returned as rx_line_error value when adding prescriptions to cart */
export enum RX_LINE_ERROR {
    NONE = 0,
    ADD_ORDER_LINE_ERROR = 1,
    ADJUDICATE_RX_ERROR = 2,
    NO_CONTRACT_WITH_PHARMACY = 40,
    NO_LONGER_COVERED = 65,
    NOT_COVERED = 70
}
